import { Component, Input, OnInit } from "@angular/core";
import { LoaderAppService } from "./loader.service";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent implements OnInit {
  @Input() customMessage: string = "";

  message!: string;
  public loader: any = {
    show: false,
  };
  constructor(private LoaderAppService: LoaderAppService) {}

  ngOnInit() {
    const currentUrl = window.location.href;
    this.loader = this.LoaderAppService.loader;
    this.message =
      currentUrl.includes("/view") || currentUrl.includes("/booking")
        ? "Fetching Hall Layout"
        : "Loading...";
  }
}
